import { Card } from "../../../card";

interface FinancialTableProps {
  data: {
    title?: string;
    headers: string[];
    rows: Array<Array<string | number>>;
  };
}

export const FinancialTable = ({ data }: FinancialTableProps) => {
  if (!data?.headers || !data?.rows || !Array.isArray(data.headers) || !Array.isArray(data.rows)) return null;

  return (
    <Card className="my-8 overflow-hidden bg-white border border-neutral-200 shadow-sm rounded-xl">
        {data.title && (
            <div className="px-6 py-4 border-b border-neutral-200">
                <h3 className="font-semibold text-lg text-neutral-900">{data.title}</h3>
            </div>
        )}
        <div className="overflow-x-auto max-h-[600px] overflow-y-auto">
          <table className="w-full text-sm text-left">
            <thead className="bg-neutral-50 text-neutral-500 font-medium sticky top-0 z-10 text-xs uppercase tracking-wider">
              <tr>
                {data.headers.map((header, idx) => (
                  <th key={idx} className={`px-6 py-3 border-b border-neutral-200 whitespace-nowrap ${idx === 0 ? 'text-left' : 'text-right'}`}>
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-neutral-200">
              {data.rows.map((row, rowIdx) => (
                <tr key={rowIdx} className="bg-white hover:bg-neutral-50 transition-colors">
                  {row.map((cell, cellIdx) => (
                    <td key={cellIdx} className={`px-6 py-4 whitespace-nowrap text-neutral-900 ${cellIdx === 0 ? 'text-left font-medium' : 'text-right font-mono text-neutral-600'}`}>
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
    </Card>
  );
};
